// import React, { useState } from "react";
// import axios from "axios";
// import "./UploadForm.css";

// function UploadForm() {
//   const [companyCode, setCompanyCode] = useState("");
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState("");
//   const [count, setCount] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!companyCode) {
//       setMessage("Please enter the company code.");
//       return;
//     }
//     if (!file) {
//       setMessage("Please select an Excel file.");
//       return;
//     }
//     const formData = new FormData();
//     formData.append("companyCode", companyCode);
//     formData.append("file", file);

//     try {
//       const resp = await axios.post("https://backend-xhl4.onrender.com/CorporateMasterRoute/upload", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       setMessage(resp.data.message);
//       setCount(resp.data.count);
//     } catch (err) {
//       console.error("Upload error:", err);
//       setMessage(
//         "Upload failed: " + (err.response?.data?.message || err.message)
//       );
//     }
//   };

//   return (
//     <div className="page-form-container">
//       <div className="upload-container">
//         <h2>Upload Employee Master File</h2>
//         <form onSubmit={handleSubmit}>
//           <label htmlFor="companyCode">Company Code</label>
//           <input
//             type="text"
//             id="companyCode"
//             value={companyCode}
//             onChange={(e) => setCompanyCode(e.target.value)}
//           />

//           <label htmlFor="file">Excel File (.xlsx)</label>
//           <input
//             type="file"
//             id="file"
//             accept=".xlsx, .xls"
//             onChange={(e) => setFile(e.target.files[0])}
//           />

//           <button type="submit">Upload</button>
//         </form>

//         {message && (
//           <div className="message">
//             {message}
//             {count !== null && <div>{`Inserted records: ${count}`}</div>}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UploadForm;

import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "./UploadForm.css";

function UploadForm() {
  const [companyCode, setCompanyCode] = useState("");
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [count, setCount] = useState(null);

  const validateExcelFile = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const rows = XLSX.utils.sheet_to_json(sheet);

          if (rows.length === 0) {
            return reject("The Excel file is empty.");
          }

          const requiredHeaders = ["Employee Code", "Full name"];
          const headers = Object.keys(rows[0]);
          const missingHeaders = requiredHeaders.filter(
            (h) => !headers.includes(h)
          );

          if (missingHeaders.length > 0) {
            return reject(
              `Invalid Excel format. Missing column(s): ${missingHeaders.join(", ")}`
            );
          }

          // Check each row
          for (const [index, row] of rows.entries()) {
            if (!row["Employee Code"] || !row["Full name"]) {
              return reject(
                `Invalid data in row ${index + 2}. Both 'Employee Code' and 'Full name' are required.`
              );
            }
          }

          resolve(true);
        } catch (err) {
          reject("Error reading Excel file. Make sure it's a valid .xlsx file.");
        }
      };
      reader.onerror = () => reject("Failed to read the Excel file.");
      reader.readAsArrayBuffer(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setCount(null);

    if (!companyCode.trim()) {
      setMessage("Please enter the company code.");
      return;
    }

    if (!file) {
      setMessage("Please select an Excel (.xlsx) file.");
      return;
    }

    if (!/\.xlsx$/i.test(file.name)) {
      setMessage("Invalid file type. Please upload a .xlsx file only.");
      return;
    }

    try {
      await validateExcelFile(file);
    } catch (validationError) {
      setMessage(validationError);
      return;
    }

    const formData = new FormData();
    formData.append("companyCode", companyCode);
    formData.append("file", file);

    try {
      const resp = await axios.post(
        "https://backend-xhl4.onrender.com/CorporateMasterRoute/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setMessage(resp.data.message);
      setCount(resp.data.count);
    } catch (err) {
      console.error("Upload error:", err);
      setMessage(
        "Upload failed: " + (err.response?.data?.message || err.message)
      );
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!/\.xlsx$/i.test(selectedFile.name)) {
      setMessage("Only .xlsx files are allowed.");
      e.target.value = "";
      setFile(null);
    } else {
      setFile(selectedFile);
      setMessage("");
    }
  };

  return (
    <div className="page-form-container">
      <div className="upload-container">
        <h2>Upload Employee Master File</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="companyCode">Company Code</label>
          <input
            type="text"
            id="companyCode"
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
          />

          <label htmlFor="file">Excel File (.xlsx)</label>
          <input
            type="file"
            id="file"
            accept=".xlsx"
            onChange={handleFileChange}
          />

          <button type="submit">Upload</button>
        </form>

        {message && (
          <div className="message">
            {message}
            {count !== null && <div>{`Inserted records: ${count}`}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

export default UploadForm;
